import React, { FC } from 'react';
import { Typography as MuiTypography } from '@mui/material';
import styled from 'styled-components';

const StandardTypography = styled(MuiTypography)<Props>`
  margin-bottom: ${(props) => (props.mb ? 0.25 * props.mb : 0)}rem;
`;

const UpperTypography = styled(MuiTypography)<Props>`
  margin-bottom: ${(props) => (props.mb ? 0.25 * props.mb : 0)}rem;
  font-size: 13px;
  font-weight: bold;
  color: #ccc;
`;

const Typography: FC<any> = ({ upper, ...props }) => {
  return upper ? (
    <UpperTypography {...props} />
  ) : (
    <StandardTypography {...props} />
  );
};

export default Typography;

interface Props{
  mb?: number,
}
